export class TibiaAnalyzerLTConfig {
}
TibiaAnalyzerLTConfig.AP_color = 0x63ADF2;
TibiaAnalyzerLTConfig.PP_color = 0x63ADF2;
TibiaAnalyzerLTConfig.AA_color = 0x63ADF2;
TibiaAnalyzerLTConfig.PA_color = 0x63ADF2;
TibiaAnalyzerLTConfig.FP_color = 0x63ADF2;
TibiaAnalyzerLTConfig.MA_color = 0x63ADF2;
TibiaAnalyzerLTConfig.apex_color = 0xFF0000;
TibiaAnalyzerLTConfig.anatomicalAxis_color = 0x63ADF2;
TibiaAnalyzerLTConfig.AP_PP_Line_color = 0x63ADF2;
TibiaAnalyzerLTConfig.AA_PA_Line_color = 0x63ADF2;
TibiaAnalyzerLTConfig.proximalMechanicalAxis_color = 0xFFFF00;
TibiaAnalyzerLTConfig.distalMechanicalAxis_color = 0xFFFF00;
TibiaAnalyzerLTConfig.PPTALabel_backgroundColor = 'rgba(0, 0, 0, 0.6)';
TibiaAnalyzerLTConfig.PPTALabel_fontColor = '#ffffff';
TibiaAnalyzerLTConfig.ADTALabel_backgroundColor = 'rgba(0, 0, 0, 0.6)';
TibiaAnalyzerLTConfig.ADTALabel_fontColor = '#ffffff';
TibiaAnalyzerLTConfig.apexLabel_backgroundColor = 'rgba(255, 255, 0, 0.6)';
TibiaAnalyzerLTConfig.apexLabel_fontColor = '#ffffff';
//# sourceMappingURL=TibiaAnalyzerLTConfig.js.map